import { Item } from "app/modules/masters/item/model/item.model";

export interface ItemState {
  items: Item[];
  loading: boolean;
  error: any;
  selectedItem: Item | null;
  total: number;
  searchResultsByRow: {
    [rowIndex: number]: Item[];
  };

   itemExists: boolean | null;
  checkingItemExists: boolean;
}


export const initialItemState: ItemState = {
  items: [],
  loading: false,
  error: null,
  selectedItem: null,
  total: 0,
  searchResultsByRow:{},
  itemExists: null,
  checkingItemExists: false,
};

